/**
 * Die Positionsdokumente einer Bestellung in drei Ladezustaenden (Fehleranzeige Paket 2, Task 13, Spec
 * `docs/superpowers/specs/2026-10-23-fehleranzeige-ladefehler-design.md`, Zeile "Positionsdokumente", Entscheidung E4).
 *
 * Bis hierher war es nur eine Liste, vorbelegt mit `[]`: ein gescheitertes Laden sah aus wie "diese Bestellung hat keine
 * Positionsdokumente" - "Noch keine Fassung." samt Upload-Knoepfen, und der Nutzer lud eine vermeintlich erste Fassung hoch.
 * Jetzt unterscheidet der Zustand, ob die Liste noch kommt, da ist oder nicht kam:
 * - `laedt`: noch keine Auskunft. Kein Leertext, keine Knoepfe.
 * - `geladen`: die Liste (auch eine leere - dann, und nur dann, ist "Noch keine Fassung." wahr).
 * - `gescheitert`: das Fehlerobjekt (`ursache`) fuer die Flaeche im Reiter Dokumente. Keine Knoepfe ohne geladenen Stand.
 *
 * Der Zustand gehoert zu EINER Bestellung (der, die der Drawer zeigt); `App.tsx` haelt die Bestellkennung daneben und reicht
 * fuer jede andere `laedt`. Der Sperrmechanismus der Upload-Sitzung (`useUploadStellen`) kennt nur "ein Upload laeuft" und
 * bleibt unberuehrt (E4).
 */
import type { PositionsDokument } from "../api/dokumente.ts";

export type PositionsDokumenteZustand =
  | { art: "laedt" }
  | { art: "geladen"; dokumente: readonly PositionsDokument[] }
  | { art: "gescheitert"; ursache: unknown };

/** Der Zustand ohne jede Auskunft; ein Aufrufer, der den Stand nicht reicht, bekommt nie Knoepfe auf unbekanntem Stand. */
export const POSITIONSDOKUMENTE_LAEDT: PositionsDokumenteZustand = { art: "laedt" };

/** Die eine leere Liste fuer jeden Zustand ohne Dokumente (stabile Identitaet: Ableitungen und Effekte sehen keinen Wechsel). */
const KEINE_POSITIONSDOKUMENTE: readonly PositionsDokument[] = [];

/**
 * Die Dokumente des Zustands: im geladenen Stand seine Liste, sonst eine leere. Alle Ableitungen (Positionen, Waisen, Vorschlaege,
 * Lightbox) rechnen damit; GEZEICHNET wird nur im geladenen Stand, die leere Liste hier ist kein Befund "es gibt keine".
 */
export function geladeneDokumente(zustand: PositionsDokumenteZustand): readonly PositionsDokument[] {
  return zustand.art === "geladen" ? zustand.dokumente : KEINE_POSITIONSDOKUMENTE;
}
